import { render, staticRenderFns } from "./Observatory.vue?vue&type=template&id=27aa3cf0&"
import script from "./Observatory.vue?vue&type=script&lang=js&"
export * from "./Observatory.vue?vue&type=script&lang=js&"
import style0 from "./Observatory.vue?vue&type=style&index=0&id=27aa3cf0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports